package com.islamicmedia.shared.domain

// navigator.language is a BCP-47 tag like "en-US" / "zh-Hans-CN" — the last 2-letter segment is the region.
actual fun deviceCountryCode(): String {
    val parts = kotlinx.browser.window.navigator.language.split('-')
    val region = if (parts.size >= 2) parts.last() else ""
    return if (region.length == 2) region.uppercase() else "US"
}
